import { useFeatureFlags } from "@squide/firefly";
import { useCallback } from "react";

const SHARED_WITH_ME_TAB_ID = "shared-with-me";

export function useIsSharedWithMeSegmentsTabHidden() {
    const isSharedSegmentsEnabled = useFeatureFlags()["enable-shared-segments"];

    return useCallback((tabId: string) => tabId === SHARED_WITH_ME_TAB_ID && !isSharedSegmentsEnabled, [isSharedSegmentsEnabled]);
}
